import { driverService } from '../_services'

export const drivers = {
  namespaced: true,
  state: {
    all: {}
  },
  actions: {
    getAll ({ commit }, { perpage, page, sortby, descending }) {
      commit('getAllRequest')

      driverService.getAll(perpage, page, sortby, descending)
        .then(
          customers => commit('getAllSuccess', customers),
          error => commit('getAllFailure', error)
        )
    }
  },
  mutations: {
    getAllRequest (state) {
      state.all = { loading: true }
    },
    getAllSuccess (state, drivers) {
      state.all = { items: drivers }
    },
    getAllFailure (state, error) {
      state.all = { error }
    }
  }
}
